import {
    FrameEditOrder,
    FrameEditScaleToolRegistration,
    FrameListOrder,
    FrameListScaleToolRegistration,
    FrameListWeighing,
    FrameWeighing,
} from '@Modules/Orders';
import { FrameEditRequisition, FrameListRequisition, RequisitionWizard } from '@Modules/Requisitions';
import { FrameEditStorageTransaction, FrameListStorageTransaction } from '@Modules/StorageTransactions';
import { RouteObject } from 'react-router';
import { setupModuleRouting } from './setupModuleRouting';

export function setupOrderRouting(): RouteObject {
    return {
        path: '',
        children: [
            setupModuleRouting({
                resourcePath: 'orders',
                editFrame: <FrameEditOrder />,
                listFrame: <FrameListOrder />,
            }),
            setupModuleRouting({
                resourcePath: 'requisitions',
                editFrame: <FrameEditRequisition />,
                listFrame: <FrameListRequisition />,
                newFrame: <RequisitionWizard />,
            }),
            setupModuleRouting({
                resourcePath: 'weighing',
                editFrame: <FrameWeighing />,
                listFrame: <FrameListWeighing />,
            }),
            setupModuleRouting({
                resourcePath: 'storage_transactions',
                editFrame: <FrameEditStorageTransaction />,
                listFrame: <FrameListStorageTransaction />,
            }),
            setupModuleRouting({
                resourcePath: 'scales',
                editFrame: <FrameEditScaleToolRegistration />,
                listFrame: <FrameListScaleToolRegistration />,
            }),
        ],
    };
}
